export default __webpack_public_path__ + "static/media/place-1.0f61ee1b.png";